import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { materialActions } from '@app/store/material/actions/material.actions';
import { materialsActions } from '../actions/materials.actions';
import { selectValue } from '../selectors/materials.selector';

@Injectable()
export class MaterialsMaterialBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    reloadAfterDelete$ = createEffect(() => {
        return this.actions.pipe(
            ofType(materialActions.deleteMaterialSuccess),
            concatLatestFrom(() => this.store.select(selectValue)),
            map(([, value]) => materialsActions.getMaterials({ value })),
        );
    });
}
